import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ImageCarousel } from "../App";

const K = {
  bg:"#F8FAFC", sur:"#FFF", alt:"#F1F5F9", brd:"#E2E8F0",
  ink:"#0F172A", mid:"#475569", lt:"#94A3B8",
  red:"#E11D48", brand:"#0284C7", gold:"#F59E0B"
};

export default function HistoryRCC() {
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    document.title = "EventosRCC | A Plataforma de Encontros da RCC";
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div style={{fontFamily:"'Inter', sans-serif", background:K.bg, color:K.ink, minHeight:"100vh", overflow:"hidden"}}>
      <style>{`
        @keyframes float1 {
          0% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(3deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }
        @keyframes float2 {
          0% { transform: translateY(0px) rotate(0deg) scale(1); }
          50% { transform: translateY(30px) rotate(-3deg) scale(1.05); }
          100% { transform: translateY(0px) rotate(0deg) scale(1); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulseGlow {
          0%, 100% { box-shadow: 0 0 20px rgba(2, 132, 199, 0.2); }
          50% { box-shadow: 0 0 50px rgba(2, 132, 199, 0.6); }
        }
        .parallax-bg {
          background-image: url('https://images.unsplash.com/photo-1438232992991-995b7058bbb3?auto=format&fit=crop&w=1920&q=80');
          background-attachment: fixed;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .reveal { animation: fadeIn 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards; opacity: 0; }
        .delay-1 { animation-delay: 0.2s; }
        .delay-2 { animation-delay: 0.4s; }
        .delay-3 { animation-delay: 0.6s; }
        .delay-4 { animation-delay: 0.8s; }
        
        .timeline-card {
          background: #fff;
          padding: 60px;
          border-radius: 30px;
          box-shadow: 0 20px 80px rgba(0,0,0,0.06);
          margin-bottom: 80px;
          position: relative;
          overflow: hidden;
          transition: transform 0.3s ease;
        }
        .timeline-card:hover {
          transform: translateY(-5px);
        }
        
        .img-hover {
          transition: transform 0.5s ease;
        }
        .img-hover:hover {
          transform: scale(1.05) rotate(1deg);
        }
        
        .year-bg {
          position: absolute;
          top: -20px;
          right: -20px;
          font-size: 160px;
          opacity: 0.03;
          font-weight: 900;
          font-family: "'Outfit', sans-serif";
          pointer-events: none;
        }

        .year-bg-left {
          position: absolute;
          top: -20px;
          left: -20px;
          font-size: 160px;
          opacity: 0.03;
          font-weight: 900;
          font-family: "'Outfit', sans-serif";
          pointer-events: none;
        }
        
        @media(max-width: 800px) {
          .grid-split { grid-template-columns: 1fr !important; }
          .timeline-card { padding: 30px; margin-bottom: 40px; }
          .hide-mob { display: none !important; }
          .year-bg, .year-bg-left { font-size: 80px; top: 10px; }
        }
      `}</style>

      {/* Header */}
      <nav style={{background:"rgba(255,255,255,0.9)", backdropFilter:"blur(10px)", borderBottom:"1px solid rgba(0,0,0,0.05)",padding:"0 24px",height:70,display:"flex",alignItems:"center",justifyContent:"space-between",position:"fixed",top:0,left:0,right:0,zIndex:50}}>
        <div style={{display:"flex", alignItems:"center", gap: 20}}>
          <span style={{fontFamily:"'Outfit',sans-serif",fontSize:24,fontWeight:800,color:K.ink,cursor:"pointer"}} onClick={()=>navigate("/")}>Eventos<span style={{color:"#009EE3"}}>&amp;</span>Encontros</span>
        </div>
        <button onClick={()=>navigate("/")} style={{background:K.ink,border:"none",color:"#fff",padding:"10px 20px",borderRadius:999,cursor:"pointer",fontWeight:600,fontSize:14,transition:"all 0.2s",boxShadow:"0 4px 12px rgba(0,0,0,0.15)"}}>← Voltar</button>
      </nav>

      {/* Parallax Hero */}
      <div className="parallax-bg" style={{height:"95vh", position:"relative", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", marginTop:70}}>
        <div style={{position:"absolute", top:0, left:0, right:0, bottom:0, background:"linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(15,23,42,1) 100%)", zIndex:1}} />
        
        <div style={{position:"relative", zIndex:2, textAlign:"center", padding:"0 24px", maxWidth:1100, transform:`translateY(${scrollY * 0.35}px)`, opacity: Math.max(0, 1 - scrollY / 250)}}>
          <div className="reveal" style={{background:"rgba(255,255,255,0.1)", backdropFilter:"blur(5px)", border:"1px solid rgba(255,255,255,0.2)", padding:"8px 24px", borderRadius:999, display:"inline-block", marginBottom:30, letterSpacing:2, fontSize:12, fontWeight:700, textTransform:"uppercase"}}>
            Mais de Meio Século de Graça
          </div>
          <h1 className="reveal delay-1" style={{fontFamily:"'Outfit', sans-serif", fontSize:"clamp(48px, 8vw, 96px)", fontWeight:900, marginBottom:24, lineHeight:1, textShadow:"0 15px 40px rgba(0,0,0,0.6)", letterSpacing:"-2px"}}>
            50+ Anos de Fogo e Espírito
          </h1>
          <p className="reveal delay-2" style={{fontSize:"clamp(18px, 2vw, 26px)", color:"rgba(255,255,255,0.85)", maxWidth:800, margin:"0 auto", lineHeight:1.6}}>
            Uma jornada imersiva pela história da Renovação Carismática Católica: desde o retiro em Duquesne até os dias de hoje.
          </p>
        </div>
        
        {/* Scroll indicator with separated animation and scroll opacity wrappers */}
        <div style={{position:"absolute", bottom:40, left:"50%", transform:"translateX(-50%)", zIndex:3, opacity: Math.max(0, 1 - scrollY/150)}}>
          <div className="reveal delay-4" style={{display:"flex", flexDirection:"column", alignItems:"center", gap:10, opacity:0.6}}>
            <span style={{fontSize:12, fontWeight:700, letterSpacing:2, textTransform:"uppercase"}}>A Linha do Tempo</span>
            <div style={{width:2, height:40, background:"linear-gradient(to bottom, transparent, #fff)", animation:"float1 2s infinite"}}/>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div style={{position:"relative", zIndex:10, background:K.ink, padding:"0 24px 120px", color:"#fff"}}>
        
        {/* LUDIC BACKGROUND ELEMENTS */}
        <div style={{position:"absolute", top: 400, left: "-10%", width: "40%", height: "800px", background:"radial-gradient(circle, rgba(2,132,199,0.15) 0%, transparent 70%)", filter:"blur(40px)", pointerEvents:"none"}}/>
        <div style={{position:"absolute", top: 1200, right: "-10%", width: "50%", height: "900px", background:"radial-gradient(circle, rgba(225,29,72,0.1) 0%, transparent 70%)", filter:"blur(60px)", pointerEvents:"none"}}/>
        <div style={{position:"absolute", top: 2200, left: "10%", width: "30%", height: "600px", background:"radial-gradient(circle, rgba(245,158,11,0.1) 0%, transparent 70%)", filter:"blur(50px)", pointerEvents:"none"}}/>
        <div style={{position:"absolute", top: 3200, right: "0%", width: "40%", height: "800px", background:"radial-gradient(circle, rgba(2,132,199,0.15) 0%, transparent 70%)", filter:"blur(50px)", pointerEvents:"none"}}/>

        <div style={{maxWidth:1200, margin:"0 auto", position:"relative", zIndex:20, marginTop:"-80px"}}>
          
          {/* Section 1: 1967 */}
          <div className="timeline-card reveal delay-3">
            <div className="year-bg">1967</div>
            <div className="grid-split" style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:50, alignItems:"center"}}>
              <div>
                <span style={{background:K.red, color:"#fff", padding:"8px 20px", borderRadius:999, fontSize:12, fontWeight:800, letterSpacing:2}}>O INÍCIO</span>
                <h2 style={{fontSize:"clamp(32px, 4vw, 48px)", fontWeight:900, color:K.ink, marginTop:24, marginBottom:24, fontFamily:"'Outfit', sans-serif", lineHeight:1.1}}>O Retiro de Duquesne</h2>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8}}>
                  Fevereiro de 1967, Pensilvânia (EUA). Um pequeno grupo de estudantes e professores da Universidade de Duquesne se reuniu para um retiro. Eles não queriam apenas ler sobre os Atos dos Apóstolos; eles clamavam por <b>viver</b> o que a Igreja Primitiva viveu.
                </p>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8, marginTop:16}}>
                  Foi diante do Sacrário na capela The Ark and The Dove que uma experiência avassaladora aconteceu: o "Batismo no Espírito Santo" reacendeu os carismas e iniciou uma corrente de graça no mundo.
                </p>
              </div>
              <div style={{position:"relative"}}>
                <img src="https://images.unsplash.com/photo-1548625361-ec8f121d5964?auto=format&fit=crop&w=800&q=80" alt="Igreja" style={{width:"100%", borderRadius:24, boxShadow:"0 30px 60px rgba(0,0,0,0.2)"}} className="img-hover" />
                <div style={{position:"absolute", bottom:-20, left:-20, background:"#fff", padding:20, borderRadius:16, boxShadow:"0 10px 30px rgba(0,0,0,0.1)", animation:"float1 5s infinite"}}>
                  <span style={{fontSize:32}}>🕊️</span>
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: 1970s - Brasil */}
          <div className="timeline-card reveal">
            <div className="year-bg-left">1970</div>
            <div className="grid-split" style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:50, alignItems:"center"}}>
              <div style={{order: window.innerWidth > 800 ? 1 : 2}}>
                <img src="/images/chegada_brasil.jpg" alt="Chegada ao Brasil" style={{width:"100%", borderRadius:24, boxShadow:"0 30px 60px rgba(0,0,0,0.2)"}} className="img-hover" />
              </div>
              <div style={{order: window.innerWidth > 800 ? 2 : 1}}>
                <span style={{background:"#10B981", color:"#fff", padding:"8px 20px", borderRadius:999, fontSize:12, fontWeight:800, letterSpacing:2}}>EXPANSÃO</span>
                <h2 style={{fontSize:"clamp(32px, 4vw, 48px)", fontWeight:900, color:K.ink, marginTop:24, marginBottom:24, fontFamily:"'Outfit', sans-serif", lineHeight:1.1}}>A Chegada ao Brasil</h2>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8}}>
                  No início da década de 1970, o movimento desembarcou no Brasil (principalmente em Campinas/SP) através de missionários jesuítas e redentoristas (como Pe. Haroldo Rahm e Pe. Eduardo Dougherty).
                </p>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8, marginTop:16}}>
                  O povo brasileiro abraçou os grupos de oração de forma calorosa. Começaram a surgir centenas de grupos semanais em paróquias, louvando com as mãos erguidas e uma profunda devoção Mariana.
                </p>
              </div>
            </div>
          </div>

          {/* Section 3: 1980s - Seminários */}
          <div className="timeline-card reveal">
             <div className="year-bg">1980</div>
             <div className="grid-split" style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:50, alignItems:"center"}}>
              <div>
                <span style={{background:K.brand, color:"#fff", padding:"8px 20px", borderRadius:999, fontSize:12, fontWeight:800, letterSpacing:2}}>FORMAÇÃO</span>
                <h2 style={{fontSize:"clamp(32px, 4vw, 48px)", fontWeight:900, color:K.ink, marginTop:24, marginBottom:24, fontFamily:"'Outfit', sans-serif", lineHeight:1.1}}>Seminários de Vida</h2>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8}}>
                  A RCC percebeu a necessidade de sistematizar o querigma (o primeiro anúncio). Surgiram os Seminários de Vida no Espírito Santo (SVES).
                </p>
                <div style={{display:"flex", alignItems:"center", gap:16, marginTop:24, background:K.alt, padding:20, borderRadius:16}}>
                  <div style={{fontSize:40}}>📖</div>
                  <p style={{fontSize:15, color:K.ink, fontWeight:600, margin:0}}>Milhões de leigos passaram a estudar a Bíblia, compreender os dons (profecia, línguas, cura) e transformar suas vidas paroquiais através dos seminários.</p>
                </div>
              </div>
              <div>
                <img src="https://images.unsplash.com/photo-1507692049790-de58290a4334?auto=format&fit=crop&w=800&q=80" alt="Espírito Santo" style={{width:"100%", borderRadius:24, boxShadow:"0 30px 60px rgba(0,0,0,0.2)"}} className="img-hover" />
              </div>
            </div>
          </div>
          
          {/* Section 4: 1990s - Música */}
          <div className="timeline-card reveal">
            <div className="year-bg-left">1990</div>
            <div className="grid-split" style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:50, alignItems:"center"}}>
              <div style={{order: window.innerWidth > 800 ? 1 : 2}}>
                <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=800&q=80" alt="Música e Louvor" style={{width:"100%", borderRadius:24, boxShadow:"0 30px 60px rgba(0,0,0,0.2)"}} className="img-hover" />
              </div>
              <div style={{order: window.innerWidth > 800 ? 2 : 1}}>
                <span style={{background:K.gold, color:"#fff", padding:"8px 20px", borderRadius:999, fontSize:12, fontWeight:800, letterSpacing:2}}>CULTURA</span>
                <h2 style={{fontSize:"clamp(32px, 4vw, 48px)", fontWeight:900, color:K.ink, marginTop:24, marginBottom:24, fontFamily:"'Outfit', sans-serif", lineHeight:1.1}}>O Boom da Música</h2>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8}}>
                  A década de 90 marcou a explosão cultural da RCC. A música ganhou força total, transformando o modo como o louvor acontecia. Ministérios de música arrastavam multidões e enchiam estádios.
                </p>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8, marginTop:16}}>
                  A televisão e as rádios católicas impulsionaram a voz da RCC, popularizando retiros gigantes, avivamentos e acampamentos focados na adoração fervorosa.
                </p>
              </div>
            </div>
          </div>
          
          {/* Section 5: 1998/2000s - Papa */}
          <div className="timeline-card reveal">
             <div className="year-bg">1998</div>
             <div className="grid-split" style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:50, alignItems:"center"}}>
              <div>
                <span style={{background:"#8B5CF6", color:"#fff", padding:"8px 20px", borderRadius:999, fontSize:12, fontWeight:800, letterSpacing:2}}>IGREJA</span>
                <h2 style={{fontSize:"clamp(32px, 4vw, 48px)", fontWeight:900, color:K.ink, marginTop:24, marginBottom:24, fontFamily:"'Outfit', sans-serif", lineHeight:1.1}}>O Reconhecimento</h2>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8}}>
                  No Pentecostes de 1998, São João Paulo II convidou os movimentos eclesiais à Praça São Pedro. O Papa reconheceu a RCC como uma "chance para a Igreja e para o mundo".
                </p>
                <p style={{fontSize:18, color:K.mid, lineHeight:1.8, marginTop:16}}>
                  O reconhecimento papal solidificou a RCC não como um movimento marginal, mas como o próprio sopro do Espírito Santo vitalizando as paróquias em todos os continentes.
                </p>
              </div>
              <div>
                <img src="/images/vaticano.jpg" alt="Vaticano" style={{width:"100%", borderRadius:24, boxShadow:"0 30px 60px rgba(0,0,0,0.2)"}} className="img-hover" />
              </div>
            </div>
          </div>

          {/* Section 6: 2017 Jubileu */}
          <div className="timeline-card reveal" style={{background:K.brand, color:"#fff", position:"relative", overflow:"hidden", marginBottom: 0}}>
            <div style={{position:"absolute", top:0, left:0, right:0, bottom:0, backgroundImage:"url('https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=80')", backgroundSize:"cover", backgroundPosition:"center", opacity:0.1, mixBlendMode:"overlay"}}/>
            <div style={{position:"absolute", top:-50, left:-50, fontSize:250, opacity:0.04, fontWeight:900, fontFamily:"'Outfit', sans-serif"}}>2017</div>
            <div style={{position:"relative", zIndex:2, textAlign:"center", padding:"60px 20px"}}>
               <span style={{background:"rgba(255,255,255,0.2)", color:"#fff", padding:"8px 20px", borderRadius:999, fontSize:12, fontWeight:800, letterSpacing:2}}>O JUBILEU DE OURO</span>
                <h2 style={{fontSize:"clamp(40px, 5vw, 64px)", fontWeight:900, color:"#fff", marginTop:24, marginBottom:24, fontFamily:"'Outfit', sans-serif", lineHeight:1}}>50 Anos de RCC</h2>
                <p style={{fontSize:20, color:"rgba(255,255,255,0.9)", lineHeight:1.6, maxWidth:800, margin:"0 auto"}}>
                  Em 2017, católicos carismáticos do mundo inteiro se reuniram em Roma com o Papa Francisco para celebrar o Jubileu de Ouro (50 anos). Mais de 120 milhões de católicos em todo o mundo já testemunham a graça do batismo no Espírito Santo.
                </p>
                <div style={{display:"flex", justifyContent:"center", marginTop:40}}>
                  <div style={{width: 60, height:4, background:"#fff", borderRadius:2}}></div>
                </div>
            </div>
          </div>

          {/* Image Carousel Section */}
          <div className="reveal" style={{marginTop:80, textAlign:"center"}}>
            <span style={{background:"rgba(255,255,255,0.1)", color:"#fff", padding:"8px 20px", borderRadius:999, fontSize:12, fontWeight:800, letterSpacing:2, textTransform:"uppercase"}}>NOSSOS ENCONTROS</span>
            <h2 style={{fontSize:"clamp(32px, 4vw, 48px)", fontWeight:900, color:"#fff", marginTop:24, marginBottom:40, fontFamily:"'Outfit', sans-serif", lineHeight:1.1}}>
              Momentos que Marcam
            </h2>
            <div style={{maxWidth:900, margin:"0 auto", boxShadow:"0 30px 60px rgba(0,0,0,0.4)", borderRadius:30, overflow:"hidden"}}>
              <ImageCarousel 
                images={[
                  "https://images.unsplash.com/photo-1543722530-d2c3201371e7?auto=format&fit=crop&w=1200&q=80",
                  "https://images.unsplash.com/photo-1525406822295-888e273a07ce?auto=format&fit=crop&w=1200&q=80",
                  "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?auto=format&fit=crop&w=1200&q=80",
                  "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?auto=format&fit=crop&w=1200&q=80"
                ]} 
                height={500} 
                borderRadius={30}
              />
            </div>
            <p style={{fontSize:16, color:"rgba(255,255,255,0.5)", marginTop:20, fontStyle:"italic"}}>Deslize para ver os encontros passados...</p>
          </div>

          {/* Call to Action Final */}
          <div className="reveal" style={{marginTop:100, textAlign:"center"}}>
            <div style={{display:"inline-flex", padding:20, background:"rgba(255,255,255,0.05)", borderRadius:100, marginBottom:30, animation:"float2 6s infinite"}}>
               <img src="/images/caminhada_religiosa.jpg" alt="Caminhada Religiosa" style={{width:120, height:120, objectFit:"cover", borderRadius:999, border:"4px solid rgba(255,255,255,0.1)"}} />
            </div>
            <h2 style={{fontSize:"clamp(40px, 5vw, 64px)", fontWeight:900, color:"#fff", marginBottom:24, fontFamily:"'Outfit', sans-serif", lineHeight:1}}>E a história continua com você.</h2>
            <p style={{fontSize:20, color:"rgba(255,255,255,0.7)", lineHeight:1.6, maxWidth:700, margin:"0 auto 40px"}}>
              Todos esses retiros, congressos e encontros de jovens acontecem todo final de semana. A plataforma <b>Eventos e Encontros</b> existe para profissionalizar essa missão e conectar você a eles.
            </p>
            <button onClick={()=>navigate("/")} style={{background:K.red, border:"none", color:"#fff", padding:"20px 48px", borderRadius:999, cursor:"pointer", fontWeight:900, fontSize:18, transition:"all 0.3s", animation:"pulseGlow 2s infinite"}} className="hov">
              GARANTIR MEU INGRESSO HOJE
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
